{
  "name": "@parcel/package-manager",
  "version": "2.11.0",
  "description": "Blazing fast, zero configuration web application bundler",
  "license": "MIT",
  "publishConfig": {
    "access": "public"
  },
  "funding": {
    "type": "opencollective",
    "url": "https://opencollective.com/parcel"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/parcel-bundler/parcel.git"
  },
  "main": "lib/index.js",
  "source": "src/index.js",
  "types": "index.d.ts",
  "engines": {
    "node": ">= 12.0.0"
  },
  "scripts": {
    "build-ts": "mkdir -p lib && flow-to-ts src/types.js > lib/types.d.ts",
    "check-ts": "tsc --noEmit index.d.ts",
    "test": "mocha test"
  },
  "targets": {
    "types": false,
    "main": {
      "includeNodeModules": {
        "@parcel/core": false,
        "@parcel/diagnostic": false,
        "@parcel/fs": false,
        "@parcel/logger": false,
        "@parcel/node-resolver-core": false,
        "@parcel/types": false,
        "@parcel/utils": false,
        "@parcel/workers": false,
        "semver": false
      }
    }
  },
  "dependencies": {
    "@parcel/diagnostic": "2.11.0",
    "@parcel/fs": "2.11.0",
    "@parcel/logger": "2.11.0",
    "@parcel/node-resolver-core": "3.2.0",
    "@parcel/types": "2.11.0",
    "@parcel/utils": "2.11.0",
    "@parcel/workers": "2.11.0",
    "semver": "^7.5.2"
  },
  "devDependencies": {
    "command-exists": "^1.2.6",
    "cross-spawn": "^6.0.4",
    "nullthrows": "^1.1.1",
    "split2": "^3.1.1"
  },
  "peerDependencies": {
    "@parcel/core": "^2.11.0"
  },
  "browser": {
    "./src/Npm.js": false,
    "./src/Pnpm.js": false,
    "./src/Yarn.js": false
  },
  "gitHead": "f8076f1644cabc944695b5ec82602c8ae32bcf21"
}
